
const postalCodeValidatorNL = (postcode) => {
    const zipFormat = new RegExp('^[0-9]{4} [A-Z]{2}$');
    return postcode && zipFormat.test(postcode);
};

export default postalCodeValidatorNL;
